import fr from '../locales/fr.json';
import de from '../locales/de.json';

export const seoConfig: Record<string, typeof fr.seo> = {
  fr: fr.seo,
  de: de.seo,
};
